import {Formik} from 'formik';
import cn from 'classnames';
import {ChangeEvent, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {RootState} from '../../../../../../store/redux';
import FormikLikeInput from '../../../../../../components/formikFileds/likeInput';
import CustomDropDown from '../../../../../../components/mazraeKit/customDropDown';
import usePostSaleAgents from '../../../../../../services/hookService/postSaleAgents/usePostSaleAgents';
import {useGetAllAgentDetail} from '../../../../../../services/hookService/getAgentStoreDetail/useGetAgentStoreDetail';
import usePutSaleAgents from '../../../../../../services/hookService/putSaleAgents/usePatchSaleAgents';
import {
  addAddress,
  clearAddress,
} from '../../../../../../store/redux/saleAgentsSelectedLocation';
import {
  addSaleAgentForm,
  clearSaleAgentForm,
} from '../../../../../../store/redux/salesAgent';
import {getLatLng} from '../../../../../../utilities/helper/getLatLng';
import {saleAgnentValidationSchema} from '../../../contants';

interface IAdvertisementTypesBottomSheet {
  refetchGetSaleAgentList?: () => void;
  cardGuid?: string;
  assigner_store?: string;
  saleAgentsBottomSheet: ISaleAgentBottomSheetProps;
  setSaleAgentsBottomSheet: React.Dispatch<
    React.SetStateAction<ISaleAgentBottomSheetProps>
  >;
}

const AddEditSaleAgentBottomSheet = ({
  assigner_store,
  cardGuid,
  saleAgentsBottomSheet,
  refetchGetSaleAgentList,
  setSaleAgentsBottomSheet,
}: IAdvertisementTypesBottomSheet) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [touched, setTouched] = useState(false);
  const [storeGuid, setStoreGuid] = useState('');

  const state = useSelector((state: RootState) => state.saleAgent);

  const saleAgentLocation = useSelector(
    (state: RootState) => state.saleAgentsLocation,
  );

  const {agentDetail, refetchGetAgentDetail} = useGetAllAgentDetail(
    state?.cardGuid as string,
  );

  const handleAfterSuccess = () => {
    dispatch(clearAddress());
    dispatch(clearSaleAgentForm());
    refetchGetAgentDetail();
    refetchGetSaleAgentList && refetchGetSaleAgentList();
  };
  const {mutate} = usePostSaleAgents(handleAfterSuccess);
  const {mutate: mutatePutSaleAgents} = usePutSaleAgents(handleAfterSuccess);

  useEffect(() => {
    if (agentDetail && !saleAgentLocation.name) {
      dispatch(
        addAddress({
          location: getLatLng(agentDetail?.location as string),
          name: ((agentDetail?.state?.name as string) +
            ' , ' +
            agentDetail?.city?.name) as string,
        }),
      );
    }
  }, [agentDetail]);

  return (
    <div>
      <Formik
        initialValues={{
          phone_number: state.phone_number || agentDetail?.phone_number,
          name: state.store_name || agentDetail?.name,
          address: state.address || agentDetail?.address,
          assigner_store: assigner_store,
        }}
        validationSchema={saleAgnentValidationSchema}
        enableReinitialize
        // validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, {setSubmitting}) => {
          setSaleAgentsBottomSheet({
            ...saleAgentsBottomSheet,
            position: false,
            type: 'addEdit',
          });

          const payload = {
            ...values,
            location: `POINT ( ${
              saleAgentLocation?.location && saleAgentLocation?.location[0]
            } ${
              saleAgentLocation?.location && saleAgentLocation?.location[1]
            } )`,
            assigner_store: assigner_store,
          };
          if (state.cardGuid) {
            mutatePutSaleAgents({
              name: values.name,
              guid: state.cardGuid,
              address: values.address,
              location: `POINT ( ${
                saleAgentLocation?.location && saleAgentLocation?.location[0]
              } ${
                saleAgentLocation?.location && saleAgentLocation?.location[1]
              } )`,
            });
          } else {
            mutate(payload);
          }
          setSubmitting(false);
        }}
      >
        {({setFieldValue, values, errors, handleSubmit, submitForm}) => {
          return (
            <form
              className="flex flex-col px-3 gap-3 pb-3"
              // onSubmit={handleSubmit}
            >
              <div className="flex justify-between my-2">
                <span className="text-red-800 text-bold">افزودن عامل فروش</span>
                <i
                  className="icon-nameClose-remove text-gray-700"
                  onClick={() =>
                    setSaleAgentsBottomSheet({
                      ...saleAgentsBottomSheet,
                      position: false,
                      type: 'addEdit',
                    })
                  }
                />
              </div>

              <CustomDropDown
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setFieldValue('phone_number', e.target.value)
                }
                cardGuid={state?.cardGuid}
                {...{setStoreGuid, storeGuid}}
              />
              <FormikLikeInput
                name="name"
                label="نام فروشگاه *"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('name', e.target.value);
                }}
              />
              <section className="flex flex-col gap-2">
                <span>آدرس فروشگاه</span>
                <div
                  className={cn(
                    ' flex gap-2 w-full h-12 rounded border-[1px] border-gray-700 items-center p-2 text-gray-700',
                    {
                      'border-[1px] border-gray-700':
                        !touched && saleAgentLocation.name,
                      ' border-[1px] !border-red-400':
                        touched && !saleAgentLocation.name,
                    },
                  )}
                  onClick={() => {
                    dispatch(
                      addSaleAgentForm({
                        ...state,
                        phone_number: values.phone_number,
                        store_name: values.name,
                        address: values.address,
                      }),
                    );
                    navigate(`/sale-agent-location-by-map/${assigner_store}`, {
                      state: {
                        assigner_store: assigner_store,
                        location:
                          saleAgentLocation.location || agentDetail?.location,
                      },
                    });
                  }}
                >
                  <i className="icon-nameLocation text-xxl" />
                  <input
                    name="location"
                    className="placeholder:text-md text-md"
                    value={saleAgentLocation.name}
                    placeholder="انتخاب محدوده*"
                  />
                </div>
                {touched && !saleAgentLocation.name && (
                  <span className="text-red-400 text-sm">
                    محدوده فروشگاه را مشخص کنید
                  </span>
                )}
                <div className="flex gap-2 border-[1px] border-gray-700 w-full h-12 rounded items-center p-2 text-gray-700 mt-2">
                  <i className="icon-nameLocation text-xxl" />
                  <input
                    className="text-md w-full h-full outline-none"
                    placeholder="خیابان و شماره پلاک را وارد کنید"
                    onChange={e => setFieldValue('address', e.target.value)}
                    value={values.address}
                  />
                </div>
              </section>
              <div className="flex flex-1 w-full gap-2">
                <button
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    setTouched(true);
                    handleSubmit();
                  }}
                  className="flex justify-center items-center flex-[2_2_0%] bg-farm-shop-500 w-full h-12 gap-2 rounded text-white text-md"
                >
                  ثبت عامل فروش
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setSaleAgentsBottomSheet({
                      ...saleAgentsBottomSheet,
                      position: false,
                      type: 'addEdit',
                    });
                    dispatch(clearSaleAgentForm());
                  }}
                  className="flex justify-center items-center flex-1 w-full h-12  gap-2 rounded border-[1px] border-farm-shop-500 text-farm-shop-500 text-md"
                >
                  انصراف
                </button>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AddEditSaleAgentBottomSheet;
